a = (function(){
	return {}
}());